import {useCurrentUserContext} from "@/components/context/hooks.ts";
import {KPICard} from "@/components/KPICard/KPICard.tsx";
import {durationSecFn, roundDurationSecs, shortDateTimeUser} from "@/lib/format.tsx";
import {LatestDowntime} from "@/lib/queries/checks.ts";

interface StatHeaderLastDowntimeProps {
  latestDowntime?: LatestDowntime;
  isUp: boolean;
}

export const StatHeaderLastDowntime = ({latestDowntime, isUp}: StatHeaderLastDowntimeProps) => {
  const {user} = useCurrentUserContext();

  return (
    <KPICard
      title={`Last Downtime${latestDowntime ? ": " + shortDateTimeUser(latestDowntime.created_at.toString(), user!) : ""}`}
    >
      {latestDowntime && (
        <>
          {isUp ? "Lasted" : "Ongoing"} for {durationSecFn(roundDurationSecs(latestDowntime.duration))}
        </>
      )}
      {!latestDowntime && <>None Recorded</>}
    </KPICard>
  );
};
